import { Picker } from "features/render";

import { ProcoreToolMode } from "./types";

export const TOOL_MODE_PICKERS: Record<ProcoreToolMode, Picker[]> = {
    [ProcoreToolMode.Default]: [],
    [ProcoreToolMode.Measure]: [Picker.OutlineLaser, Picker.Coordinates, Picker.PointLine, Picker.Dimension],
    [ProcoreToolMode.Section]: [Picker.SectionPlane],
    [ProcoreToolMode.Markup]: [],
    [ProcoreToolMode.Create]: [],
};

const PICKERS_TO_TOOL_MODES: Partial<Record<Picker, ProcoreToolMode>> = Object.fromEntries(
    Object.entries(TOOL_MODE_PICKERS).flatMap(([mode, pickers]) => pickers.map((picker) => [picker, mode])),
);

export function getToolModeForPicker(picker: Picker): ProcoreToolMode | undefined {
    return PICKERS_TO_TOOL_MODES[picker];
}

export const DEFAULT_MEASURE_PICKER = Picker.PointLine;
export const DEFAULT_SECTION_PICKER = Picker.SectionPlane;
